// project imports
import { NavItemType } from '@/types/menu';
import cityzenGroups from './cityzen';
import accesGroups from './acces';
import administrare from './administrare';

// types

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [...cityzenGroups, ...accesGroups, administrare]
};

export default menuItems;
